import { render } from "./AssistantWithSpark.vue?vue&type=template&id=ef3a006c&scoped=true"
import script from "./AssistantWithSpark.vue?vue&type=script&lang=js"
export * from "./AssistantWithSpark.vue?vue&type=script&lang=js"

import "./AssistantWithSpark.vue?vue&type=style&index=0&id=ef3a006c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3a006c"],['__file',"src/Components/ChatWidget/AssistantAi/Icons/AssistantWithSpark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef3a006c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef3a006c', __exports__)) {
    api.reload('ef3a006c', __exports__)
  }
  
  module.hot.accept("./AssistantWithSpark.vue?vue&type=template&id=ef3a006c&scoped=true", () => {
    api.rerender('ef3a006c', render)
  })

}


export default __exports__